/**
 * Do not edit directly
 * Generated on Mon, 15 Dec 2025 06:35:42 GMT
 */

export const colorPrimaryPrimary = "#004bee";
export const colorPrimaryOnPrimary = "#ffffff";
export const colorPrimaryPrimaryContainer = "#c2c8f5";
export const colorPrimaryOnPrimaryContainer = "#06164b";
export const colorSecondarySecondary = "#5a5d72";
export const colorSecondaryOnSecondary = "#ffffff";
export const colorSecondarySecondaryContainer = "#dee1f9";
export const colorSecondaryOnSecondaryContainer = "#171b2c";
export const colorTertiaryTertiary = "#75546f";
export const colorTertiaryOnTertiary = "#ffffff";
export const colorTertiaryTertiaryContainer = "#ffd7f4";
export const colorTertiaryOnTertiaryContainer = "#2c1229";
export const colorErrorError = "#ba1a1a";
export const colorErrorOnError = "#ffffff";
export const colorErrorErrorContainer = "#ffdad6";
export const colorErrorOnErrorContainer = "#410002";
export const colorWarningWarning = "#f1be4b";
export const colorWarningWarningContainer = "#fff2b8";
export const colorSurfaceSurface = "#ffffff";
export const colorSurfaceSurfaceVar = "#f1f5ff";
export const colorSurfaceSurfaceOpacity8 = "#004bee14";
export const colorSurfaceSurfaceOpacity12 = "#004bee1f";
export const colorOutlineOutline = "#aeb7f9";
export const colorOutlineOutlineVar = "#b4cbff";
export const colorLinkPrimary = "#004bee";
export const colorDisabledDisabled = "#17191c59";
export const colorDisabledOnColorDisabled = "#e4e3db61";
export const colorSuccessSuccess = "#5e8700";
export const colorSuccessSuccessContainer = "#e3eec9";
export const textPrimaryPrimary = "#1b1c17";
export const textPrimaryOnColorPrimary = "#f2f1e9";
export const textSecondarySecondary = "#5e5f59";
export const textSecondaryOnColorSecondary = "#c8c7bf";
export const textLinkOnColorLink = "#c2c8f5";
export const textLinkOnSurfaceLink = "#004bee";
export const textDisabledDisabled = "#17191c59"; // To be used only for disabled text and icons
export const textDisabledOnColorDisabled = "#e4e3dbc2"; // To be used only for disabled text and icons
export const textErrorErrorText = "#ba1a1a";
export const textErrorOnColorError = "#ffffff";
export const textWarningWarning = "#ff8c00"; // To be used only for disabled text and icons
export const textSuccessSuccess = "#5e8700"; // To be used only for disabled text and icons
export const textSuccessSuccessContainer = "#e3eec9"; // To be used only for disabled text and icons
export const primitivesPrimaryPrimary0 = "#000000";
export const primitivesPrimaryPrimary10 = "#06164b";
export const primitivesPrimaryPrimary40 = "#004bee";
export const primitivesPrimaryPrimary20 = "#253500";
export const primitivesPrimaryPrimary30 = "#384e00";
export const primitivesPrimaryPrimary50 = "#648123";
export const primitivesPrimaryPrimary60 = "#7d9b3b";
export const primitivesPrimaryPrimary70 = "#97b653";
export const primitivesPrimaryPrimary80 = "#b1d26b";
export const primitivesPrimaryPrimary99 = "#faffe5";
export const primitivesPrimaryPrimary100 = "#ffffff";
export const primitivesPrimaryPrimary90 = "#c2c8f5";
export const primitivesPrimaryPrimary95 = "#dffba2";
export const primitivesPrimaryPrimaryCustom = "#004bee";
export const primitivesSecondarySecondary0 = "#000000";
export const primitivesSecondarySecondary10 = "#171b2c";
export const primitivesSecondarySecondary50 = "#5a5d72";
export const primitivesSecondarySecondary20 = "#2c331d";
export const primitivesSecondarySecondary30 = "#424a31";
export const primitivesSecondarySecondary40 = "#5a5d72";
export const primitivesSecondarySecondary60 = "#8c9477";
export const primitivesSecondarySecondary70 = "#a7af90";
export const primitivesSecondarySecondary80 = "#c2caaa";
export const primitivesSecondarySecondary90 = "#dee1f9";
export const primitivesSecondarySecondary95 = "#ecf5d3";
export const primitivesSecondarySecondary99 = "#faffe5";
export const primitivesSecondarySecondary100 = "#ffffff";
export const primitivesTertiaryTertiary0 = "#000000";
export const primitivesTertiaryTertiary10 = "#2c1229";
export const primitivesTertiaryTertiary20 = "#013732";
export const primitivesTertiaryTertiary30 = "#204e48";
export const primitivesTertiaryTertiary40 = "#75546f";
export const primitivesTertiaryTertiary50 = "#527f79";
export const primitivesTertiaryTertiary60 = "#6b9992";
export const primitivesTertiaryTertiary70 = "#86b4ad";
export const primitivesTertiaryTertiary80 = "#a0d0c8";
export const primitivesTertiaryTertiary90 = "#ffd7f4";
export const primitivesTertiaryTertiary95 = "#cafaf2";
export const primitivesTertiaryTertiary99 = "#f2fffb";
export const primitivesTertiaryTertiary100 = "#ffffff";
export const primitivesErrorError0 = "#000000";
export const primitivesErrorError10 = "#410002";
export const primitivesErrorError20 = "#690005";
export const primitivesErrorError30 = "#93000a";
export const primitivesErrorError40 = "#ba1a1a";
export const primitivesErrorError50 = "#de3730";
export const primitivesErrorError60 = "#ff5449";
export const primitivesErrorError70 = "#ff897d";
export const primitivesErrorError80 = "#ffb4ab";
export const primitivesErrorError90 = "#ffdad6";
export const primitivesErrorError100 = "#ffffff";
export const primitivesErrorError95 = "#ffdad6";
export const primitivesErrorError99 = "#fffbff";
export const primitivesWarningWarningCus1 = "#f1be4b";
export const primitivesWarningWarning10 = "#2f2204";
export const primitivesWarningWarningCus2 = "#ff8c00";
export const primitivesWarningWarningSurface = "#fff2b8";
export const primitivesWarningWarning20 = "#5f4407";
export const primitivesWarningWarning30 = "#8e660b";
export const primitivesWarningWarning40 = "#bd880f";
export const primitivesWarningWarning50 = "#ecaa13";
export const primitivesNeutralNeutral99 = "#f1f5ff";
export const primitivesNeutralNeutral100 = "#ffffff";
export const primitivesNeutralNeutral10 = "#1b1c17";
export const primitivesNeutralNeutral20 = "#30312c";
export const primitivesNeutralNeutral40 = "#5e5f59";
export const primitivesNeutralNeutral50 = "#777771";
export const primitivesNeutralNeutral30 = "#474742";
export const primitivesNeutralNeutral60 = "#91918a";
export const primitivesNeutralNeutral70 = "#acaba4";
export const primitivesNeutralNeutral80 = "#c8c7bf";
export const primitivesNeutralNeutral90 = "#e4e3db";
export const primitivesNeutralNeutral95 = "#f2f1e9";
export const primitivesNeutralNeutral0 = "#000000";
export const primitivesNeutralVariantNeutralVariant40 = "#5d6053";
export const primitivesNeutralVariantNeutralVariant60 = "#909284";
export const primitivesNeutralVariantNeutralVariant80 = "#b4cbff";
export const primitivesNeutralVariantNeutralVariant50 = "#aeb7f9";
export const primitivesNeutralVariantNeutralVariant70 = "#aaad9e";
export const primitivesNeutralVariantNeutralVariant30 = "#45483c";
export const primitivesNeutralVariantNeutralVariant90 = "#e2e4d4";
export const primitivesNeutralVariantNeutralVariant95 = "#f0f2e2";
export const primitivesNeutralVariantNeutralVariant99 = "#b4cbff";
export const primitivesNeutralVariantNeutralVariant100 = "#ffffff";
export const primitivesNeutralVariantNeutralVariant10 = "#1a1d13";
export const primitivesNeutralVariantNeutralVariant20 = "#2f3227";
export const primitivesNeutralVariantNeutralVariant0 = "#000000";
export const primitivesSuccessSuccess10 = "#5e8700";
export const primitivesSuccessSuccess20 = "#e3eec9";
export const spacing0 = "0";
export const spacing2 = "2px";
export const radius0 = "0";
export const primitiveSpace0 = 0;
export const primitiveSpace2 = 2;
export const primitiveSpace4 = 4;
export const primitiveSpace8 = 8;
export const primitiveSpace12 = 12;
export const primitiveSpace16 = 16;
export const primitiveSpace20 = 20;
export const primitiveSpace24 = 24;
export const primitiveSpace28 = 28;
export const primitiveSpace32 = 32;
export const primitiveSpace36 = 36;
export const primitiveSpace40 = 40;
export const primitiveSpace44 = 44;
export const primitiveSpace48 = 48;
export const primitiveSpace52 = 52;
export const primitiveRadius0 = 0;
export const primitiveRadius2 = 2;
export const primitiveRadius4 = 4;
export const primitiveRadius8 = 8;
export const primitiveRadius12 = 12;
export const primitiveRadius16 = 16;
export const primitiveRadius20 = 20;
export const primitiveRadius24 = 24;
export const primitiveRadius28 = 28;
export const primitiveRadius32 = 32;
export const primitiveRadius100 = 100;
export const primitiveRadius005 = 0.5;
export const primitiveRadius05 = 0.5;
export const spacing4 = "2px";
export const spacing8 = "8px";
export const spacing12 = "12px";
export const spacing16 = "16px";
export const spacing20 = "20px";
export const spacing24 = "24px";
export const spacing28 = "28px";
export const spacing32 = "32px";
export const spacing36 = "36px";
export const spacing40 = "40px";
export const spacing44 = "44px";
export const spacing48 = "48px";
export const spacing52 = "52px";
export const radius005 = "0.5px";
export const radius2 = "2px";
export const radius4 = "4px";
export const radius8 = "8px";
export const radius12 = "12px";
export const radius16 = "16px";
export const radius20 = "20px";
export const radius24 = "24px";
export const radius28 = "28px";
export const radius32 = "32px";
export const radius100 = "100px";
export const m3ElevationLight10Color = "#00000026";
export const m3ElevationLight10Type = "dropShadow";
export const m3ElevationLight10X = 0;
export const m3ElevationLight10Y = 1;
export const m3ElevationLight10Blur = 3;
export const m3ElevationLight10Spread = 1;
export const m3ElevationLight11Color = "#0000004d";
export const m3ElevationLight11Type = "dropShadow";
export const m3ElevationLight11X = 0;
export const m3ElevationLight11Y = 1;
export const m3ElevationLight11Blur = 2;
export const m3ElevationLight11Spread = 0;
export const m3ElevationLight20Color = "#00000026";
export const m3ElevationLight20Type = "dropShadow";
export const m3ElevationLight20X = 0;
export const m3ElevationLight20Y = 2;
export const m3ElevationLight20Blur = 6;
export const m3ElevationLight20Spread = 2;
export const m3ElevationLight21Color = "#0000004d";
export const m3ElevationLight21Type = "dropShadow";
export const m3ElevationLight21X = 0;
export const m3ElevationLight21Y = 1;
export const m3ElevationLight21Blur = 2;
export const m3ElevationLight21Spread = 0;
export const m3ElevationLight30Color = "#0000004d";
export const m3ElevationLight30Type = "dropShadow";
export const m3ElevationLight30X = 0;
export const m3ElevationLight30Y = 1;
export const m3ElevationLight30Blur = 3;
export const m3ElevationLight30Spread = 0;
export const m3ElevationLight31Color = "#00000026";
export const m3ElevationLight31Type = "dropShadow";
export const m3ElevationLight31X = 0;
export const m3ElevationLight31Y = 4;
export const m3ElevationLight31Blur = 8;
export const m3ElevationLight31Spread = 3;
export const m3ElevationLight40Color = "#0000004d";
export const m3ElevationLight40Type = "dropShadow";
export const m3ElevationLight40X = 0;
export const m3ElevationLight40Y = 2;
export const m3ElevationLight40Blur = 3;
export const m3ElevationLight40Spread = 0;
export const m3ElevationLight41Color = "#00000026";
export const m3ElevationLight41Type = "dropShadow";
export const m3ElevationLight41X = 0;
export const m3ElevationLight41Y = 6;
export const m3ElevationLight41Blur = 10;
export const m3ElevationLight41Spread = 4;
export const m3ElevationLight50Color = "#0000004d";
export const m3ElevationLight50Type = "dropShadow";
export const m3ElevationLight50X = 0;
export const m3ElevationLight50Y = 4;
export const m3ElevationLight50Blur = 4;
export const m3ElevationLight50Spread = 0;
export const m3ElevationLight51Color = "#00000026";
export const m3ElevationLight51Type = "dropShadow";
export const m3ElevationLight51X = 0;
export const m3ElevationLight51Y = 8;
export const m3ElevationLight51Blur = 12;
export const m3ElevationLight51Spread = 6;
export const m3DisplayLargeFontFamily = "Manrope";
export const m3DisplayLargeFontWeight = 700;
export const m3DisplayLargeLineHeight = "AUTO";
export const m3DisplayLargeFontSize = "57px";
export const m3DisplayLargeLetterSpacing = "-0.25";
export const m3DisplayLargeParagraphSpacing = 0;
export const m3DisplayLargeParagraphIndent = "0px";
export const m3DisplayLargeTextCase = "none";
export const m3DisplayLargeTextDecoration = "none";
export const m3DisplayMediumFontFamily = "Manrope";
export const m3DisplayMediumFontWeight = 700;
export const m3DisplayMediumLineHeight = "AUTO";
export const m3DisplayMediumFontSize = "45px";
export const m3DisplayMediumLetterSpacing = "0";
export const m3DisplayMediumParagraphSpacing = 0;
export const m3DisplayMediumParagraphIndent = "0px";
export const m3DisplayMediumTextCase = "none";
export const m3DisplayMediumTextDecoration = "none";
export const m3DisplaySmallFontFamily = "Manrope";
export const m3DisplaySmallFontWeight = 700;
export const m3DisplaySmallLineHeight = "AUTO";
export const m3DisplaySmallFontSize = "36px";
export const m3DisplaySmallLetterSpacing = "0";
export const m3DisplaySmallParagraphSpacing = 0;
export const m3DisplaySmallParagraphIndent = "0px";
export const m3DisplaySmallTextCase = "none";
export const m3DisplaySmallTextDecoration = "none";
export const m3HeadlineLargeFontFamily = "Manrope";
export const m3HeadlineLargeFontWeight = 700;
export const m3HeadlineLargeLineHeight = "AUTO";
export const m3HeadlineLargeFontSize = "32px";
export const m3HeadlineLargeLetterSpacing = "0";
export const m3HeadlineLargeParagraphSpacing = 0;
export const m3HeadlineLargeParagraphIndent = "0px";
export const m3HeadlineLargeTextCase = "none";
export const m3HeadlineLargeTextDecoration = "none";
export const m3HeadlineMediumFontFamily = "Manrope";
export const m3HeadlineMediumFontWeight = 700;
export const m3HeadlineMediumLineHeight = "AUTO";
export const m3HeadlineMediumFontSize = "28px";
export const m3HeadlineMediumLetterSpacing = "0";
export const m3HeadlineMediumParagraphSpacing = 0;
export const m3HeadlineMediumParagraphIndent = "0px";
export const m3HeadlineMediumTextCase = "none";
export const m3HeadlineMediumTextDecoration = "none";
export const m3HeadlineSmallFontFamily = "Manrope";
export const m3HeadlineSmallFontWeight = 700;
export const m3HeadlineSmallLineHeight = "AUTO";
export const m3HeadlineSmallFontSize = "24px";
export const m3HeadlineSmallLetterSpacing = "0";
export const m3HeadlineSmallParagraphSpacing = 0;
export const m3HeadlineSmallParagraphIndent = "0px";
export const m3HeadlineSmallTextCase = "none";
export const m3HeadlineSmallTextDecoration = "none";
export const m3TitleLargeFontFamily = "Manrope";
export const m3TitleLargeFontWeight = 700;
export const m3TitleLargeLineHeight = "AUTO";
export const m3TitleLargeFontSize = "22px";
export const m3TitleLargeLetterSpacing = "0";
export const m3TitleLargeParagraphSpacing = 0;
export const m3TitleLargeParagraphIndent = "0px";
export const m3TitleLargeTextCase = "none";
export const m3TitleLargeTextDecoration = "none";
export const m3TitleMediumFontFamily = "Manrope";
export const m3TitleMediumFontWeight = 700;
export const m3TitleMediumLineHeight = "AUTO";
export const m3TitleMediumFontSize = "16px";
export const m3TitleMediumLetterSpacing = "0.15";
export const m3TitleMediumParagraphSpacing = 0;
export const m3TitleMediumParagraphIndent = "0px";
export const m3TitleMediumTextCase = "none";
export const m3TitleMediumTextDecoration = "none";
export const m3TitleSmallFontFamily = "Manrope";
export const m3TitleSmallFontWeight = 700;
export const m3TitleSmallLineHeight = "AUTO";
export const m3TitleSmallFontSize = "14px";
export const m3TitleSmallLetterSpacing = "0.1";
export const m3TitleSmallParagraphSpacing = 0;
export const m3TitleSmallParagraphIndent = "0px";
export const m3TitleSmallTextCase = "none";
export const m3TitleSmallTextDecoration = "none";
export const m3TitleSemiLargeFontFamily = "Manrope";
export const m3TitleSemiLargeFontWeight = 700;
export const m3TitleSemiLargeLineHeight = "AUTO";
export const m3TitleSemiLargeFontSize = "22px";
export const m3TitleSemiLargeLetterSpacing = "0.15";
export const m3TitleSemiLargeParagraphSpacing = 0;
export const m3TitleSemiLargeParagraphIndent = "0px";
export const m3TitleSemiLargeTextCase = "none";
export const m3TitleSemiLargeTextDecoration = "none";
export const m3BodyLargeFontFamily = "Manrope";
export const m3BodyLargeFontWeight = 500;
export const m3BodyLargeLineHeight = "AUTO";
export const m3BodyLargeFontSize = "16px";
export const m3BodyLargeLetterSpacing = "0.5";
export const m3BodyLargeParagraphSpacing = 0;
export const m3BodyLargeParagraphIndent = "0px";
export const m3BodyLargeTextCase = "none";
export const m3BodyLargeTextDecoration = "none";
export const m3BodyMediumFontFamily = "Manrope";
export const m3BodyMediumFontWeight = 500;
export const m3BodyMediumLineHeight = "AUTO";
export const m3BodyMediumFontSize = "14px";
export const m3BodyMediumLetterSpacing = "0.25";
export const m3BodyMediumParagraphSpacing = 0;
export const m3BodyMediumParagraphIndent = "0px";
export const m3BodyMediumTextCase = "none";
export const m3BodyMediumTextDecoration = "none";
export const m3BodySmallFontFamily = "Manrope";
export const m3BodySmallFontWeight = 500;
export const m3BodySmallLineHeight = "AUTO";
export const m3BodySmallFontSize = "12px";
export const m3BodySmallLetterSpacing = "0.4";
export const m3BodySmallParagraphSpacing = 0;
export const m3BodySmallParagraphIndent = "0px";
export const m3BodySmallTextCase = "none";
export const m3BodySmallTextDecoration = "none";
export const m3LabelLargeProminentFontFamily = "Manrope";
export const m3LabelLargeProminentFontWeight = 700;
export const m3LabelLargeProminentLineHeight = "AUTO";
export const m3LabelLargeProminentFontSize = "14px";
export const m3LabelLargeProminentLetterSpacing = "0.1";
export const m3LabelLargeProminentParagraphSpacing = 0;
export const m3LabelLargeProminentParagraphIndent = "0px";
export const m3LabelLargeProminentTextCase = "none";
export const m3LabelLargeProminentTextDecoration = "none";
export const m3LabelLargeFontFamily = "Manrope";
export const m3LabelLargeFontWeight = 600;
export const m3LabelLargeLineHeight = "AUTO";
export const m3LabelLargeFontSize = "14px";
export const m3LabelLargeLetterSpacing = "0.1";
export const m3LabelLargeParagraphSpacing = 0;
export const m3LabelLargeParagraphIndent = "0px";
export const m3LabelLargeTextCase = "none";
export const m3LabelLargeTextDecoration = "none";
export const m3LabelMediumProminentFontFamily = "Manrope";
export const m3LabelMediumProminentFontWeight = 700;
export const m3LabelMediumProminentLineHeight = "AUTO";
export const m3LabelMediumProminentFontSize = "12px";
export const m3LabelMediumProminentLetterSpacing = "0.5";
export const m3LabelMediumProminentParagraphSpacing = 0;
export const m3LabelMediumProminentParagraphIndent = "0px";
export const m3LabelMediumProminentTextCase = "none";
export const m3LabelMediumProminentTextDecoration = "none";
export const m3LabelMediumFontFamily = "Manrope";
export const m3LabelMediumFontWeight = 600;
export const m3LabelMediumLineHeight = "AUTO";
export const m3LabelMediumFontSize = "12px";
export const m3LabelMediumLetterSpacing = "0.5";
export const m3LabelMediumParagraphSpacing = 0;
export const m3LabelMediumParagraphIndent = "0px";
export const m3LabelMediumTextCase = "none";
export const m3LabelMediumTextDecoration = "none";
export const m3LabelSmallFontFamily = "Manrope";
export const m3LabelSmallFontWeight = 600;
export const m3LabelSmallLineHeight = "AUTO";
export const m3LabelSmallFontSize = "11px";
export const m3LabelSmallLetterSpacing = "0.5";
export const m3LabelSmallParagraphSpacing = 0;
export const m3LabelSmallParagraphIndent = "0px";
export const m3LabelSmallTextCase = "none";
export const m3LabelSmallTextDecoration = "none";
export const m3LabelLargeCapFontFamily = "Manrope";
export const m3LabelLargeCapFontWeight = 700;
export const m3LabelLargeCapLineHeight = "AUTO";
export const m3LabelLargeCapFontSize = "14px";
export const m3LabelLargeCapLetterSpacing = "0.1";
export const m3LabelLargeCapParagraphSpacing = 0;
export const m3LabelLargeCapParagraphIndent = "0px";
export const m3LabelLargeCapTextCase = "uppercase";
export const m3LabelLargeCapTextDecoration = "none";
export const m3LinkLargeFontFamily = "Manrope";
export const m3LinkLargeFontWeight = 600;
export const m3LinkLargeLineHeight = "AUTO";
export const m3LinkLargeFontSize = "14px";
export const m3LinkLargeLetterSpacing = "0.1";
export const m3LinkLargeParagraphSpacing = 0;
export const m3LinkLargeParagraphIndent = "0px";
export const m3LinkLargeTextCase = "none";
export const m3LinkLargeTextDecoration = "underline";
export const m3LinkMediumFontFamily = "Manrope";
export const m3LinkMediumFontWeight = 600;
export const m3LinkMediumLineHeight = "AUTO";
export const m3LinkMediumFontSize = "12px";
export const m3LinkMediumLetterSpacing = "0.5";
export const m3LinkMediumParagraphSpacing = 0;
export const m3LinkMediumParagraphIndent = "0px";
export const m3LinkMediumTextCase = "none";
export const m3LinkMediumTextDecoration = "underline";
export const m3LinkSmallFontFamily = "Manrope";
export const m3LinkSmallFontWeight = 600;
export const m3LinkSmallLineHeight = "AUTO";
export const m3LinkSmallFontSize = "11px";
export const m3LinkSmallLetterSpacing = "0.5";
export const m3LinkSmallParagraphSpacing = 0;
export const m3LinkSmallParagraphIndent = "0px";
export const m3LinkSmallTextCase = "none";
export const m3LinkSmallTextDecoration = "underline";
export const lineHeights0 = "AUTO";
export const lineHeights1 = "52";
export const lineHeights2 = "44";
export const lineHeights3 = "40";
export const lineHeights4 = "36";
export const lineHeights5 = "32";
export const lineHeights6 = "28";
export const lineHeights7 = "24";
export const lineHeights8 = "20";
export const lineHeights9 = "26";
export const lineHeights10 = "16";
export const lineHeights11 = "16";
export const fontSize0 = "11px";
export const fontSize1 = "12px";
export const fontSize2 = "14px";
export const fontSize3 = "16px";
export const fontSize4 = "22px";
export const fontSize5 = "24px";
export const fontSize6 = "28px";
export const fontSize7 = "32px";
export const fontSize8 = "36px";
export const fontSize9 = "45px";
export const fontSize10 = "57px";
export const fontSize11 = "34px";
export const fontSize12 = "38px";
export const fontSize13 = "46px";
export const fontSize14 = "58px";
export const letterSpacing0 = "-0.25";
export const letterSpacing1 = "0";
export const letterSpacing2 = "0.15";
export const letterSpacing3 = "0.1";
export const letterSpacing4 = "0.5";
export const letterSpacing5 = "0.25";
export const letterSpacing6 = "0.4";
export const paragraphSpacing0 = 0;
export const textCaseNone = "none";
export const textCaseUppercase = "uppercase";
export const textDecorationNone = "none";
export const textDecorationUnderline = "underline";
export const paragraphIndent0 = "0px";
export const fontFamiliesManrope = "Manrope";
export const fontWeightsManrope0 = 700;
export const fontWeightsManrope1 = 500;
export const fontWeightsManrope2 = 600;
export const tokenSetOrder0 = "Tokens/light";
